<template>
  <article>
    <table class="table--normal table--first200">
      <tr>
        <td rowspan="2">
          <b style="font-size: 16px;">
            {{ fullLocaleStartdate }}
          </b>
        </td>
        <td rowspan="2">
          <header>
            <h1>{{ entry['title_' + locale] || entry.title }}</h1>
            {{ $t('ui.content.at_location') }}
            <address>
              <a :href="'https://www.google.com/maps/place/' + entry.location + '/'">{{ entry.location }}</a>
            </address>
          </header>
          <p>
            {{ entry['summary_' + locale] || entry.summary }}
          </p>
          <p>
            {{ localeDateRange }}
            <br />
            {{ localeTimeFrame }}
          </p>
          <p v-if="eventUrl">
            <a :href="eventUrl">{{ $t('ui.content.more_info') }}</a>
          </p>
        </td>
      </tr>
    </table>
  </article>
</template>

<script>
import { locale } from '../locale';
import { urlify } from '../util';

export default {
  name: 'EventEntry',
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      locale,
    };
  },
  computed: {
    eventUrl() {
      if (this.entry[`content_${locale}`] || this.entry.content) {
        return `/#/events/${urlify(this.entry.title)}`;
      }
      return this.entry.url;
    },
    fullLocaleStartdate() {
      return new Date(this.entry.dateRange[0]).toLocaleDateString(locale, {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      });
    },
    localeDateRange() {
      let dateRange = '';
      dateRange += `${this.$t('ui.content.from_date')
        .charAt(0)
        .toUpperCase() + this.$t('ui.content.from_date').slice(1)} `;
      dateRange += new Date(this.entry.dateRange[0]).toLocaleDateString(locale, { month: 'long', day: 'numeric' });
      const endDate = new Date(this.entry.dateRange[1] || this.entry.dateRange[0]).toLocaleDateString(locale, {
        month: 'long',
        day: 'numeric',
      });
      dateRange += endDate ? ' ' + this.$t('ui.content.until_date') + ' ' + endDate : '';
      return dateRange;
    },
    localeTimeFrame() {
      return new Date(this.entry.dateRange[0]).getHours() !== 0
        ? `ab ${new Date(this.entry.dateRange[0]).toLocaleTimeString(locale, {
            hour: 'numeric',
            minute: '2-digit',
          })} Uhr`
        : '';
    },
  },
};
</script>

<style></style>
